document.addEventListener('change', (event) => {
  const select = event.target.closest('.ho-cart-upsell select');
  if (!select) return;
  const price = select.selectedOptions[0]?.dataset.price;
  if (price) select.closest('.ho-cart-upsell').querySelector('.ho-cart-upsell__price').textContent = price;
});
document.addEventListener('cart:error', (event) => {
  const message = event.target.closest('.ho-cart-upsell')?.querySelector('.ho-cart-upsell__error');
  if (message) {
    message.textContent = event.detail.error;
    message.hidden = false;
  }
}, true);
